import React, { PureComponent } from 'react';
import { DropdownButton, MenuItem, Button } from 'react-bootstrap';
import { UserRole } from '@upstart/harmony/lib/constants';
import PropTypes from 'prop-types';
import './AccessDealerForm.scss';

export default class AccessDealerForm extends PureComponent {
  renderDealers = () => {
    const { dealers, onSelectDealer } = this.props;
    return dealers.map((dealer) => (
      <MenuItem
        key={dealer.id}
        className="dropdown-dealers-items"
        eventKey={dealer.id}
        onSelect={() => onSelectDealer(dealer)}
      >
        {dealer.name}
      </MenuItem>
    ));
  };

  render() {
    const { onLogout, onContinueWithoutDealer, user, dealers } = this.props;
    return (
      <div className="access-dealer-container">
        <div className="dropdown-container">
          {dealers.length === 0 && (
            <div className="dropdown-dealers">
              You do not have access to any dealerships.
            </div>
          )}
          {dealers.length !== 0 && (
            <DropdownButton
              className="dropdown-dealers"
              title="Select a Dealer"
              id="select-a-dealer"
            >
              {this.renderDealers()}
            </DropdownButton>
          )}
        </div>
        <div className="access-dealer-buttons">
          {user &&
            (user.roles.includes(UserRole.SUPER_ADMIN) ||
              user.roles.includes(UserRole.ADMIN) ||
              user.roles.includes(UserRole.READ_ONLY_ADMIN)) && (
              <Button
                className="btn-continue"
                onClick={onContinueWithoutDealer}
              >
                Continue as Admin
              </Button>
            )}
          <Button className="btn-logout" color="blue" onClick={onLogout}>
            Logout
          </Button>
        </div>
      </div>
    );
  }
}

AccessDealerForm.propTypes = {
  user: PropTypes.object,
  dealers: PropTypes.array,
  onSelectDealer: PropTypes.func,
  onContinueWithoutDealer: PropTypes.func,
  onLogout: PropTypes.func,
};
